import { Form } from 'antd';
import { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';

import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import { formatCurrency, IExportExcels } from 'utils/constants/functions';

interface IProps {
  ref: any;
  data: any[];
  title: string;
  loading?: boolean;
  isApprove?: boolean;
  pagination?: boolean;
  year?: any;
}

interface TableRef {
  getData: () => IExportExcels;
}

const monthIndexes = [
  'janSaleamt',
  'febSaleamt',
  'marSaleamt',
  'aprSaleamt',
  'maySaleamt',
  'junSaleamt',
  'julSaleamt',
  'augSaleamt',
  'sepSaleamt',
  'octSaleamt',
  'novSaleamt',
  'decSaleamt',
];

const TableHOFollowPlanDetail = forwardRef<TableRef, IProps>(
  ({ data, loading = false, pagination = true, year }, ref) => {
    const [form] = Form.useForm();

    const renderColumn = useCallback((value: any) => {
      const formattedValue = formatCurrency({
        value,
      });

      return formattedValue === '' || formattedValue === null
        ? 0
        : formattedValue;
    }, []);

    const columns: ColumnsTypeCustom = useMemo(
      () => [
        {
          fixed: 'left',
          width: 150,
          align: 'left',
          title: '-',
          dataIndex: ['title'],
        },
        {
          width: 150,
          align: 'left',
          title: 'Chi nhánh',
          dataIndex: ['plant'],
        },
        ...(monthIndexes.map((month, index) => ({
          currency: 'vi-VN',
          width: 160,
          type: 'number',
          align: 'right',
          title: index === 12 ? String(year) : `Tháng ${index + 1}`,
          dataIndex: index + 1,
          render: (value: any) => renderColumn(value),
        })) as any),
        {
          currency: 'vi-VN',
          width: 160,
          type: 'number',
          align: 'right',
          title: 'Tổng năm',
          dataIndex: 'total',
          render: (value: any) => renderColumn(value),
        },
      ],
      [renderColumn, year],
    );

    const getData = useCallback(
      (): IExportExcels => ({
        datas: data,
        isShowSTT: true,
        headerRow: columns,
      }),
      [columns, data],
    );

    useImperativeHandle(ref, () => ({ getData }), [getData]);

    return (
      <Form form={form}>
        <TableComponent
          rowKey={(record: any) => record.id}
          columns={columns}
          dataSource={data}
          loading={loading}
          tableLayout="fixed"
          style={{ whiteSpace: 'nowrap' }}
          pagination={false}
        />
      </Form>
    );
  },
);

export default TableHOFollowPlanDetail;
